import { render, staticRenderFns } from "./wf.vue?vue&type=template&id=70cd69c0&scoped=true"
import script from "./wf.vue?vue&type=script&lang=js"
export * from "./wf.vue?vue&type=script&lang=js"
import style0 from "./wf.vue?vue&type=style&index=0&id=70cd69c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd69c0",
  null
  
)

export default component.exports